import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as apiActions from 'api-actions'
import { selectors as apiSelectors } from 'lp-redux-api'
import ServicesAgreementParticipantsView from '../components/ServicesAgreementParticipantsView'

const propTypes = {
  servicesAgreementParticipants: PropTypes.arrayOf(Types.rolloverAccount),
  fetchServicesAgreementParticipants: PropTypes.func.isRequired,
  isFetchingServicesAgreementParticipants: PropTypes.bool.isRequired,
  servicesAgreementId: PropTypes.string.isRequired,
  baseFilters: PropTypes.shape({
    status: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  filters: PropTypes.shape({
    status: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  handleFilter: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  fieldMappings: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const defaultProps = {
  servicesAgreementParticipants: null,
}

function ServicesAgreementParticipants({
  servicesAgreementParticipants,
  fetchServicesAgreementParticipants,
  isFetchingServicesAgreementParticipants,
  servicesAgreementId,
  baseFilters,
  filters,
  handleFilter,
  search,
  handleSearch,
  fieldMappings,
}) {
  return (
    <ServicesAgreementParticipantsView
      participants={servicesAgreementParticipants}
      fetchServicesAgreementParticipants={fetchServicesAgreementParticipants}
      isFetching={isFetchingServicesAgreementParticipants}
      servicesAgreementId={servicesAgreementId}
      fieldMappings={fieldMappings}
      search={search}
      handleSearch={handleSearch}
      filters={filters}
      baseFilters={baseFilters}
      handleFilter={handleFilter}
      fileName="Inspira Financial_Retirement Services_ARO Participants"
    />
  )
}

ServicesAgreementParticipants.propTypes = propTypes
ServicesAgreementParticipants.defaultProps = defaultProps

function mapStateToProps(state, { servicesAgreementId }) {
  return {
    servicesAgreementParticipants: selectors.servicesAgreementParticipants(
      state,
      { servicesAgreementId }
    ),
    isFetchingServicesAgreementParticipants: apiSelectors.isLoading(
      state,
      apiActions.fetchServicesAgreementParticipants
    ),
  }
}

const mapDispatchToProps = {
  fetchServicesAgreementParticipants:
    apiActions.fetchServicesAgreementParticipants,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ServicesAgreementParticipants
)
